import React from "react";
import styled from "styled-components";

import { StemElement } from "@examspark/types";

import { useDrop } from "../../common/drag/useDrag";

import ImageMap from "./image-map/ImageMap";

const Styled = styled.div`
  position: relative;
  display: inline-block;
  border: solid 1px #ddd;
  transition: border-color 0.2s;

  .item-player-img-token {
    position: absolute;
  }
`;

interface Props {
  data: StemElement;
}

/**
 * Image background with selectable hotspots, that can also accept draggables.
 *
 * Not recommended if you DON'T want this to be used as a droppable.
 *
 * @param props
 */
const Stage: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const dropRef = useDrop({
    id: props.data.id,
  });

  return (
    <Styled>
      {props.data.content.image && (
        <ImageMap
          image={props.data.content.image}
          onInit={(canvas) => {
            dropRef.current = canvas;
          }}
          map={{
            areas: props.data.content.spots,
          }}
        />
      )}
      {props.children}
    </Styled>
  );
};

export default Stage;
